"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDetailsColumns = void 0;
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const models_1 = require("../../../api/ecommerce/models");
const array_1 = require("../../../common/js/helper/array");
const string_1 = require("../../../common/js/helper/string");
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const media_1 = require("../../helper/media");
const money_1 = require("../../helper/money");
const order_1 = require("../../helper/order");
const payment_1 = require("../../helper/payment");
const UiStore_1 = __importDefault(require("../../stores/UiStore"));
const InfoBox_1 = __importDefault(require("../InfoBox"));
const TableSub_1 = __importDefault(require("../TableSub"));
class UserProfileOrdersTableDetails extends react_1.default.Component {
    rowElementRef = react_1.default.createRef();
    componentDidMount() {
        if (this.props.data?.id === this.props.match.params.orderId && !!this.rowElementRef.current) {
            this.rowElementRef.current.parentElement?.previousElementSibling?.scrollIntoView(true);
        }
    }
    render() {
        const { data } = this.props;
        const products = data?.lineItems
            ?.filter((lineItem) => lineItem.type === models_1.LineItemTypeEnum.Product)
            .sort((a, b) => {
            const additionalSeatSorting = (a.payload?.massiveIsAdditionalSeats ? 1 : 0) - (b.payload?.massiveIsAdditionalSeats ? 1 : 0);
            if (0 !== additionalSeatSorting) {
                return additionalSeatSorting;
            }
            return (a.position ?? 0) - (b.position ?? 0);
        }) ?? [];
        const isoCode = data?.currency?.isoCode ?? '';
        return (react_1.default.createElement("div", { className: "znd-orders-table-sub", ref: this.rowElementRef },
            react_1.default.createElement("div", { className: "d-flex flex-row" }, products.length > 0 ? (react_1.default.createElement(TableSub_1.default, { columns: (0, exports.getDetailsColumns)(isoCode), data: products, className: "znd-orders-table-sub__table" })) : null),
            react_1.default.createElement("div", { className: "d-flex flex-row align-items-start mt-3" },
                getShippingAndPurchase(data),
                getBillingAndPayment(data),
                getBannerAdvancedPayment(data),
                getAllPrices(data, isoCode))));
    }
}
exports.default = (0, react_i18next_1.withTranslation)()((0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(UserProfileOrdersTableDetails)));
const renderLineItemPrice = (label, value, key) => {
    return (react_1.default.createElement("tr", { key: key, className: "znd-orders-table-sub__prices-sub" },
        react_1.default.createElement("td", null, label),
        react_1.default.createElement("td", null, value)));
};
const renderOrderAddress = (address) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (0, string_1.displayElement)('span', address?.company),
        (0, string_1.displayElement)('span', address?.street),
        (0, string_1.displayElement)('span', address?.zipcode),
        (0, string_1.displayElement)('span', address?.city),
        (0, string_1.displayElement)('span', [address?.countryState?.translated?.name, address?.country?.translated?.name]
            .filter((element) => !!element)
            .join(', '))));
};
const getShippingAndPurchase = (order) => {
    const delivery = order?.deliveries ? order?.deliveries[0] : null;
    if (delivery === null) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "d-flex flex-column znd-orders-table-sub__column mr-5" },
        react_1.default.createElement("span", { className: "znd-orders-table-sub__column-label" }, (0, translation_1.t)('user.profile.orders.shipping_method')),
        (0, string_1.displayElement)('span', delivery.shippingMethod?.translated?.name),
        react_1.default.createElement("span", { className: "mt-3 znd-orders-table-sub__column-label" }, (0, translation_1.t)('user.profile.orders.shipping_address')),
        renderOrderAddress(delivery.shippingOrderAddress),
        order?.customFields?.massivePurchaseOrderNumber ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "mt-3 znd-orders-table-sub__column-label" },
                ' ',
                (0, translation_1.t)('user.profile.orders.purchase_order_number')),
            (0, string_1.displayElement)('span', order?.customFields?.massivePurchaseOrderNumber))) : null));
};
const getBillingAndPayment = (order) => {
    const paymentMethod = order ? (0, payment_1.getCurrentOrderPaymentMethod)(order) : null;
    return (react_1.default.createElement("div", { className: "d-flex flex-column znd-orders-table-sub__column mr-5" },
        react_1.default.createElement("span", { className: "znd-orders-table-sub__column-label" }, (0, translation_1.t)('user.profile.orders.payment_method')),
        (0, string_1.displayElement)('span', paymentMethod?.translated?.name),
        react_1.default.createElement("span", { className: "mt-3 znd-orders-table-sub__column-label" }, (0, translation_1.t)('user.profile.orders.billing_address')),
        renderOrderAddress(order?.billingAddress),
        order?.customerComment ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "mt-3 znd-orders-table-sub__column-label" }, (0, translation_1.t)('user.profile.orders.customer_comment')),
            (0, string_1.displayElement)('p', order?.customerComment, 'znd-orders-table-sub__column-comment'))) : null));
};
const renderDiscountOrSurcharge = (lineItems, isoCode) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, lineItems
        .filter((lineItem) => (lineItem.totalPrice ?? 0) !== 0)
        .map((lineItem) => renderLineItemPrice(`${lineItem.label}:`, (lineItem.totalPrice && lineItem.totalPrice < 0 ? '– ' : '') +
        ' ' +
        (isNaN(Number(lineItem.totalPrice))
            ? lineItem.totalPrice
            : (0, money_1.moneyFormat)(Math.abs(Number(lineItem.totalPrice)), isoCode)), lineItem.id))));
};
const getAllPrices = (order, isoCode) => {
    const shippingCosts = (0, money_1.moneyFormat)(order?.shippingCosts?.totalPrice ?? 0, isoCode);
    const totalCosts = (0, money_1.moneyFormat)(order?.price?.totalPrice ?? 0, isoCode);
    const totalPricesOfProducts = (0, money_1.moneyFormat)(order?.lineItems
        ?.filter((lineItem) => lineItem.type === models_1.LineItemTypeEnum.Product)
        .reduce((sum, lineItem) => sum + (lineItem.totalPrice ?? 0), 0) ?? 0, isoCode);
    const surcharges = order?.lineItems?.filter((lineItem) => lineItem.type === models_1.LineItemTypeEnum.Surcharge) ?? [];
    const promotions = order?.lineItems?.filter((lineItem) => lineItem.type === models_1.LineItemTypeEnum.Promotion) ?? [];
    return (react_1.default.createElement("table", { className: "znd-orders-table-sub__prices" },
        react_1.default.createElement("tbody", null,
            renderLineItemPrice((0, translation_1.t)('user.profile.orders.subtotal'), totalPricesOfProducts),
            renderDiscountOrSurcharge(surcharges, isoCode),
            renderDiscountOrSurcharge(promotions, isoCode),
            renderLineItemPrice((0, translation_1.t)('user.profile.orders.shipping'), shippingCosts),
            renderLineItemPrice((0, translation_1.t)('user.profile.orders.tax'), (0, order_1.calculateTaxes)(order, true)),
            react_1.default.createElement("tr", { className: "znd-orders-table-sub__prices-total" },
                react_1.default.createElement("td", null, (0, translation_1.t)('user.profile.orders.price_total')),
                react_1.default.createElement("td", null, totalCosts)))));
};
const getBannerAdvancedPayment = (order) => {
    const reference = order?.customFields?.zkpSoftwareOfferId ?? order?.orderNumber ?? null;
    const advancePaymentText = (0, translation_1.t)('payment.advance_payment.text', {
        channel: AuthorizationStore_1.default.channelId ?? null,
        reference,
    });
    const paid = (0, array_1.first)(order?.lineItems ?? [])?.payload?.zkpPaid ?? null;
    const paymentDueDate = (0, array_1.first)(order?.lineItems ?? [])?.payload?.zkpSoftwareOfferOfferEndDate ?? null;
    // Show advanced payment information until payment due date (offer end date) is reached and the order has not been paid yet.
    if (true === paid || (null !== paymentDueDate && UiStore_1.default.sixtySeconds > paymentDueDate)) {
        return null;
    }
    const showAdvancedPaymentText = true === order?.customFields?.massiveIsAdvancePayment && !!advancePaymentText;
    return showAdvancedPaymentText ? (react_1.default.createElement(InfoBox_1.default, { innerHtml: advancePaymentText, className: "znd-orders-table-sub__info-box mr-5 my-0" })) : null;
};
const ItemImageColumn = () => ({
    name: '',
    sortable: false,
    minWidth: '11.625rem',
    cell: (lineItem) => lineItem.cover ? (react_1.default.createElement("div", { className: "znd-orders-table-sub__image-wrapper" },
        react_1.default.createElement("img", { className: "znd-orders-table-sub__image", ...(0, media_1.imageSourceFromMedia)(lineItem.cover) }))) : null,
});
const ItemProductColumn = () => ({
    name: (0, translation_1.t)('user.profile.orders.table.item.product.column_name'),
    selector: (lineItem) => lineItem.label ?? '',
    sortable: true,
});
const ItemQuantityColumn = () => ({
    name: (0, translation_1.t)('user.profile.orders.table.item.quantity.column_name'),
    selector: (lineItem) => lineItem.quantity ?? 0,
    sortable: true,
});
const ItemPriceColumn = (isoCode) => ({
    name: (0, translation_1.t)('user.profile.orders.table.item.price.column_name'),
    selector: (lineItem) => lineItem.totalPrice ?? 0,
    sortable: true,
    right: true,
    format: (lineItem) => (0, money_1.moneyFormat)(lineItem.totalPrice ?? 0, isoCode),
});
const defaultColumnsCallback = (isoCode) => [
    ItemImageColumn(),
    ItemProductColumn(),
    ItemQuantityColumn(),
    ItemPriceColumn(isoCode),
];
const getDetailsColumns = (isoCode) => defaultColumnsCallback(isoCode);
exports.getDetailsColumns = getDetailsColumns;
